export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "containers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "packages_from_stock_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cajas disponibles"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "total_packages_from_stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cajas disponibles"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of process"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "total_packages_from_stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Packages from stock"])}
        }
      }
    }
  })
}